import {Col, Row, Form, Button, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import ParticipantForm from "../form/participantForm";
import {Link, useParams} from "react-router-dom";
import ApiService from "../../services/ApiService";
import {format} from "date-fns";
import AppRoute from "../../utils/AppRoute";
import eventBus from "../../utils/EventBus";
import GenericErrorModal from "../modal/genericErrorModal";
import useLevels from "../../utils/hooks/useLevels";

const Booking = () => {

    const {courseId} = useParams();
    const [optionItem, setOptionItem] = useState([])
    const [courseData, setCourseData] = useState({});
    const [livello, setLivello] = useState()
    const [show, setShow] = useState(false);
    const [participantList, setParticipantList] = useState([]);
    const [selectedParticipant, setSelectedParticipant] = useState();
    const [nomeCognome, setNomeCognome] = useState("");
    const [dataDiNascita, setDataDiNascita] = useState();
    const [selectedLevel, setSelectedLevel] = useState("");
    const [loading, setLoading] = useState(true);
    const levels = useLevels();

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    useEffect(() => {
        ApiService.getCourseById(courseId).then((jObj) => {
            setCourseData(jObj);
        }).catch(() => {}).finally(() => setLoading(false))

        ApiService.getParticipantByUserId().then((jObj) => {
            createSelectItem(jObj)
        })

        ApiService.getLevelById(courseData.levelCourseId).then(livello => {
            setLivello(livello)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const createSelectItem = (participantList) => {
        let items = [];
        let partList = []
        items.push(<option value={-1}>Seleziona partecipante</option>)
        for (let i = 0; i < participantList.participantDtoList.length; i++) {
            let currentParticipant = participantList.participantDtoList[i]
            partList.push(currentParticipant)
            items.push(<option key={i}
                               value={i}>{currentParticipant.firstName} {currentParticipant.lastName}</option>);
        }

        setParticipantList(partList)
        setOptionItem(items);
    }

    const handleIscriviPartecipante = async (event) => {
        event.preventDefault();
        saveOrderData()
    }

    const handleRegistraAndIscriviPartecipante = async (event) => {
        event.preventDefault();

        let partNomeCognome = nomeCognome.split(" ");
        let participantParameter = {
            firstName: partNomeCognome[0],
            lastName: partNomeCognome[1],
            dob: dataDiNascita + " 00:00",
            currentLevel: selectedLevel
        }

        ApiService.createPartecipant(participantParameter)
            .then(partJson => {
                setSelectedParticipant(partJson)
                saveOrderData(partJson)
            })
            .catch(response => setErrorModal({
                state: true,
                title: "Errore nella creazione del partecipante",
                body: "Ok"
            }))
    }

    const saveOrderData = (partJson) => {

        let participantObj = partJson? partJson : selectedParticipant

        ApiService.getBasketData().then(async activeBasket => {

            let data = {
                price: courseData.price,
                courseId: courseData.id,
                participantId: participantObj.id,
                basketId: activeBasket.id
            }
            ApiService.createBookCourse(data).then(response => {
                console.log("Creato")
                eventBus.dispatch("bookCourseCreated");
                setShow(true)
            })
                .catch(error => {
                    if(error.status === 400){
                        setErrorModal({
                            state: true,
                            title: "Impossibile registrare il partecipante due volte allo stesso corso",
                            body: "Ok"
                        })
                    } else if (error.status === 409) {
                        setErrorModal({
                            state: true,
                            title: "Errore. Il corso risulta già al completo",
                            body: "Ok"
                        })
                    } else {
                        setErrorModal({
                            state: true,
                            title: "Errore generico, si prega di riprovare",
                            body: "Ok"
                        })
                    }
                })
        })
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    // Un corso e' iscrivibile solo dentro la sua finestra di visibilita' (stesso
    // criterio della lista lato server). Blocca l'iscrizione ai corsi vecchi/chiusi.
    const isCourseOpen = (c) => {
        if (!c || !c.visibilityStart || !c.visibilityEnd) return false;
        const now = new Date();
        const parse = (s) => new Date(String(s).replace(' ', 'T'));
        return now >= parse(c.visibilityStart) && now <= parse(c.visibilityEnd);
    };
    const courseClosed = !loading && !isCourseOpen(courseData);

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={'title-page-section mt-5 header-detail'}>
                                <h2 className={'title'}>
                                    {courseData.title}, Livello {livello && livello.level}<br/>
                                    Dettaglio partecipante
                                </h2>
                            </div>
                        </Col>
                    </Row>

                    {courseClosed &&
                        <Row className={'mt-4'}>
                            <Col>
                                <div className={'alert alert-warning'}>
                                    <p className={'fw-bold mb-1'}>Iscrizioni non disponibili</p>
                                    <p className={'mb-0'}>Questo corso non è al momento disponibile per l'iscrizione.</p>
                                </div>
                            </Col>
                        </Row>
                    }

                    <Row className={'mt-4'}>
                        <Col>
                            <Form>
                                <Form.Group className="mb-3" controlId="participant">
                                    <Form.Label>Seleziona partecipante dal tuo profilo*</Form.Label>
                                    <Form.Select aria-label="Default select example" className={'w-100 mb-3'}
                                                 onChange={(e) => setSelectedParticipant(participantList[e.target.value])}>
                                        {optionItem}
                                    </Form.Select>
                                </Form.Group>
                                <p>*campi obbligatori</p>

                                <div className={'d-flex justify-content-end'}>
                                    <Button type={'submit'} className={'px-5 fw-bold'} variant={'primary'}
                                            disabled={selectedParticipant === null || selectedParticipant === undefined || selectedParticipant === "" || courseClosed}
                                            onClick={(e) => handleIscriviPartecipante(e)}>
                                        Iscrivi partecipante
                                    </Button>

                                    {selectedParticipant &&
                                        <>
                                            <Modal show={show} onHide={() => setShow(false)} backdrop='static'
                                                   keyboard="False"
                                                   size="lg" centered>
                                                <Modal.Header className={'justify-content-end py-0'}>
                                                    <Button variant={'link'} onClick={() => setShow(false)}>
                                                        chiudi x
                                                    </Button>
                                                </Modal.Header>
                                                <Modal.Body className={'mt-4 mb-5'}>
                                                    <h2 className={'title fw-bold'}>Riepilogo</h2>
                                                    <div>
                                                        <table className="table">
                                                            <thead>
                                                            <tr>
                                                                <th scope={'col'}>Corso</th>
                                                                <th scope={'col'}>Partecipante</th>
                                                                <th scope={'col'} className={'text-end'}>Prezzo</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                <td className={'border-end'}>
                                                                    {courseData.title},<br/>
                                                                    Livello {livello && livello.level}<br/>
                                                                    {courseData.noOfLessons + "lezioni"}
                                                                </td>
                                                                <td className={'border-end'}>
                                                                    {selectedParticipant.firstName} {selectedParticipant.lastName}<br/>
                                                                    {format(new Date(selectedParticipant.dob), "dd.MM.yyyy")}<br/>
                                                                    Livello {selectedParticipant.currentLevel}
                                                                </td>
                                                                <td className={'text-end'}>{parseFloat(courseData.price).toFixed(2)} CHF</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </Modal.Body>
                                                <Modal.Footer className={'pt-0 justify-content-between'}>
                                                    <Link to={AppRoute.BASE} className={'btn btn-primary fw-bold px-3'}>
                                                        Continua con lo shopping
                                                    </Link>
                                                    <Link to={AppRoute.CART} className={'btn btn-primary fw-bold px-3'}>
                                                        Vai al carrello
                                                    </Link>
                                                </Modal.Footer>
                                            </Modal>
                                        </>
                                    }
                                </div>
                            </Form>
                        </Col>
                    </Row>

                    <Row className={'pt-5 my-5'}>
                        <Col>
                            <Form>
                                <h5 className={'fw-bold'}>Iscrivi nuovo partecipante</h5>
                                <ParticipantForm setDataDiNascita={setDataDiNascita} setNomeCognome={setNomeCognome}
                                                 levels={levels} setSelectedLevel={setSelectedLevel} />
                                <div className={'w-100 d-flex justify-content-end'}>
                                    <Button type={'submit'} className={'px-5 fw-bold'} variant={'primary'}
                                            disabled={(nomeCognome === "" || dataDiNascita === undefined || selectedLevel === "") || courseClosed}
                                            onClick={(e) => handleRegistraAndIscriviPartecipante(e)}>
                                        Iscrivi partecipante
                                    </Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

        </>

    );
}

export default Booking;
